const specialCharacterMap: Record<string, string> = {
  á: 'a',
  à: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  å: 'a',
  ā: 'a',
  ă: 'a',
  ą: 'a',
  æ: 'ae',
  ç: 'c',
  ć: 'c',
  č: 'c',
  ċ: 'c',
  ď: 'd',
  đ: 'd',
  ð: 'd',
  é: 'e',
  è: 'e',
  ê: 'e',
  ë: 'e',
  ē: 'e',
  ė: 'e',
  ę: 'e',
  ě: 'e',
  ĝ: 'g',
  ğ: 'g',
  ġ: 'g',
  ģ: 'g',
  ĥ: 'h',
  ħ: 'h',
  í: 'i',
  ì: 'i',
  î: 'i',
  ï: 'i',
  ī: 'i',
  į: 'i',
  ı: 'i',
  ĵ: 'j',
  ķ: 'k',
  ĺ: 'l',
  ļ: 'l',
  ľ: 'l',
  ł: 'l',
  ń: 'n',
  ň: 'n',
  ñ: 'n',
  ņ: 'n',
  ó: 'o',
  ò: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  ő: 'o',
  ō: 'o',
  œ: 'oe',
  ŕ: 'r',
  ř: 'r',
  ś: 's',
  š: 's',
  ş: 's',
  ș: 's',
  ß: 'ss',
  ť: 't',
  ţ: 't',
  ț: 't',
  þ: 'th',
  ú: 'u',
  ù: 'u',
  û: 'u',
  ü: 'u',
  ū: 'u',
  ů: 'u',
  ű: 'u',
  ų: 'u',
  ŵ: 'w',
  ý: 'y',
  ÿ: 'y',
  ź: 'z',
  ż: 'z',
  ž: 'z',
}

export function mapSpecialCharacters(text: string): string {
  return [...text].map(char => specialCharacterMap[char] || char).join('')
}
